export const dragsubject = (simulation: any, event: any) => {
  return simulation.find(event.x, event.y);
};
export const dragstarted = (simulation: any, event: any) => {
  if (!event.active) simulation.alphaTarget(0.3).restart();
  event.subject.fx = event.subject.x;
  event.subject.fy = event.subject.y;
};
export const dragged = (event: any) => {
  event.subject.fx = event.x;
  event.subject.fy = event.y;
};
export const dragended = (simulation: any, event: any) => {
  if (!event.active) simulation.alphaTarget(0);
  event.subject.fx = null;
  event.subject.fy = null;
};

export const tick = (node: any, link: any) => {
  link
    .attr("x1", function (d: any) {
      return d.source.x;
    })
    .attr("y1", function (d: any) {
      return d.source.y;
    })
    .attr("x2", function (d: any) {
      return d.target.x;
    })
    .attr("y2", function (d: any) {
      return d.target.y;
    });
  node.style("transform", (d: any) => `translate(${d.x}px, ${d.y}px)`);
};
